import { ListItem } from "@mui/material";
import {
	FrontendCompanyWorkflow,
	FrontendCompanyWorkflowSteps,
} from "node-library/dist/structures/frontendTestWorkflowStructureDefinitions";
import StarIcon from "@mui/icons-material/Star";

interface Props {
	step: FrontendCompanyWorkflowSteps;
	workflow: FrontendCompanyWorkflow;
	currentStep: FrontendCompanyWorkflowSteps | undefined;
	renderingStepId: string | undefined;
	setStepToRender: (step: FrontendCompanyWorkflowSteps) => void;
}

export function WorkflowStepItem(props: Props) {
	const { step, workflow, currentStep, renderingStepId, setStepToRender } =
		props;
	return (
		<ListItem
			alignItems="flex-start"
			sx={{
				flexDirection: "column",
				alignItems: "stretch",
				border: renderingStepId === step.stepId ? "1px solid black" : "none",
				cursor: "pointer",
			}}
			onClick={() => setStepToRender(step)}
		>
			<div
				style={{
					display: "flex",
					gap: "5px",
					alignItems: "center",
				}}
			>
				{currentStep?.stepId === step.stepId && (
					<div style={{ display: "flex", color: "#4dd7af" }}>
						<StarIcon />
					</div>
				)}
				<div className="typography-body-01">{step.stepName}</div>
			</div>

			{step.stepDescription && (
				<div className="typography-body-01">{step.stepDescription}</div>
			)}
		</ListItem>
	);
}
